import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';


export class IDeclaration extends BaseEntity {
    shiftId: string;
    employeeId: string;
    name: string;
    dateTimeFrom: any;
    dateTimeTo: any;
    status: number;
    registrationType: string;
    // OUDE (blijft voor backward compatibility):
    wageCodeId: string;
    wageCodeCode: string;
    wageCodeName?: string; // Toevoegen voor display
    // NIEUWE (toevoegen):
    hourCodeId?: string;
    hourCodeCode?: string;
    hourCodeName?: string;
    duration: number;
    value: number;
    invoiceId?: string; // Toevoegen om te checken of gefactureerd
    sendToCootje?: boolean; // Toevoegen om te checken of naar Cootje gestuurd
    forceRecalculate?: boolean; // Toevoegen voor override
}

export class DeclarationService extends BaseService<IDeclaration> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'declaration');
    }

    public confirm(data): ng.IPromise<any> {
        return this.Restangular.all(this.itemName).one('confirm').customPOST(data).then((item) => {
            return item;
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/declarations.service.ts